import React, { useCallback } from "react";
import { Statistic } from '../../PSY/Statistic'
import { COL_PRICE, LIQUIDATION_PRICE } from '../../../lexicon'
import { MINIMUM_COLLATERAL_RATIO, Decimal, LiquityStoreState } from '@liquity/lib-base'
import { useLiquitySelector } from "@liquity/lib-react"
import { useAppState } from "../../../hooks/AppStateContext";

type Props = {
  collateral: Decimal
  debt: Decimal
}

export const Price: React.FC<Props> = ({ collateral, debt} ) => {
  const { currentCollateralKey } = useAppState();

  const selector = useCallback(({ collateralStates }: LiquityStoreState) => {
    if (!currentCollateralKey) {
      return { price: Decimal.ZERO }
    }
    const collateralState = collateralStates[currentCollateralKey];

    return {
      price: collateralState.price
    };
  }, [currentCollateralKey]);

  const { price } = useLiquitySelector(selector);
  const liquidationPrice = MINIMUM_COLLATERAL_RATIO.mul(debt).div(collateral)

  return (
    <div className="bg-component border-component p-5 flex flex-col justify-between">
      <div className="text-style-heading">Price</div>
      <div className="flex flex-col mt-6">
        <Statistic lexicon={COL_PRICE} >
          ${price.prettify(2)}
        </Statistic>
        <Statistic lexicon={LIQUIDATION_PRICE} border={false}>
          {liquidationPrice.infinite ? "" : "$"}
          {liquidationPrice.prettify(2)}
        </Statistic>
      </div>
    </div>
  );
};
